import script from "./erpnews.vue?vue&type=script&setup=true&lang=js"
export * from "./erpnews.vue?vue&type=script&setup=true&lang=js"

import "./erpnews.vue?vue&type=style&index=0&id=3597b3e7&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3597b3e7"]])

export default __exports__